module.exports = __webpack_public_path__ + "static/img/logo-footer.89b2dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-footer.png
// module id = +PBE
// module chunks = 10